<fa-icon [icon]="faSpinner" size="5x"></fa-icon>
